import defaultSettings from "@/settings"

const title = defaultSettings.title || "株式会社M-NET"

export default function getPageTitle (pageTitle) {
    if (pageTitle) {
        return `${pageTitle} - ${title}`
    }
    return `${title}`
}
